import type { Configuration } from '|>/core'

import { useMemo } from 'react'

/**
 * Hook to handle Player configuration
 * !This is NOT a VideoJS options!
 * Returns memoized options object, that will not change between renders
 */
export function useConfiguration({
  using,
  onReady,
  chromecast,
  cmcd,
  dolby,
  smartlib,
}: Configuration) {
  return useMemo(() => {
    return {
      using,
      chromecast,
      cmcd,
      dolby,
      smartlib,
      onReady,
    } satisfies Configuration
  }, [JSON.stringify(cmcd), dolby, smartlib?.enabled])
}
